import { toJSONDate } from "src/app/helpers/date";

export function convertQueryStringInput(queryStrings: IDataQueryString[] | Object = []) {
    var qStringArr: IDataQueryString[] = [];

    //assume obj!
    if (!(queryStrings instanceof Array)) {
        for (let key in queryStrings) {
            var val = queryStrings[key];

            qStringArr.push({
                name: key,
                value: val
            })
        }
    }
    else {
        qStringArr = queryStrings;
    }

    return qStringArr;
}

export function setQueryStringAttachments(values: IDataQueryString[], ignoreNameList: string[] = []): string {

    var qString = "";

    for (var i = 0; i < values.length; i++) {
        var v = values[i];

        if (v.value !== undefined && v.value !== null && v.value !== "") {

            if (qString === "") {
                qString += "?";
            }
            else {
                qString += "&";
            }

            if (ignoreNameList.indexOf(v.name) === -1)
                qString += v.name + "=" + (v.value instanceof Date ? toJSONDate(v.value) : typeof v.value === 'string' ? v.value.replace("T00:00:00Z", "") : v.value);

        }

    }

    return qString;
}


export interface IDataQueryString {
    name: string;
    value: any;
}